var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 40,
    viewBox: "0 0 205 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1152_29232)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 10,
    r: 10,
    fill: "#0061DB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#00C791"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 10,
    fill: "#8633FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.4,
    cy: 30,
    r: 10,
    fill: "#FF1F6A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.333 17.14C196.946 15.5056 197.951 14.2798 199.347 13.4626C200.777 12.6454 202.36 12.2368 204.097 12.2368V19.5917C202.088 19.3533 200.283 19.7619 198.683 20.8175C197.117 21.873 196.333 23.6266 196.333 26.0782V38.2852H189.745V12.7476H196.333V17.14Z",
    fill: "#121826"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.634 28.2231C166.52 31.4238 168.92 33.0242 172.836 33.0242C175.356 33.0242 177.263 32.1729 178.557 30.4704L183.868 33.5349C181.349 37.1783 177.637 39 172.734 39C168.512 39 165.124 37.7231 162.57 35.1693C160.016 32.6156 158.739 29.3978 158.739 25.5161C158.739 21.6684 159.999 18.4677 162.519 15.9139C165.039 13.3261 168.273 12.0322 172.223 12.0322C175.969 12.0322 179.05 13.3261 181.468 15.9139C183.919 18.5018 185.145 21.7025 185.145 25.5161C185.145 26.3673 185.06 27.2697 184.89 28.2231H165.634ZM165.532 23.1156H178.557C178.182 21.379 177.399 20.0851 176.207 19.2338C175.049 18.3826 173.721 17.957 172.223 17.957C170.453 17.957 168.988 18.4166 167.831 19.336C166.673 20.2213 165.907 21.4811 165.532 23.1156Z",
    fill: "#121826"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.448 38.2849V1H154.037V38.2849H147.448Z",
    fill: "#121826"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.42 39C128.573 39 125.355 37.7061 122.767 35.1182C120.213 32.5304 118.937 29.3297 118.937 25.5161C118.937 21.7025 120.213 18.5018 122.767 15.9139C125.355 13.3261 128.573 12.0322 132.42 12.0322C134.906 12.0322 137.17 12.6281 139.213 13.8199C141.256 15.0116 142.806 16.612 143.861 18.6209L138.192 21.9408C137.681 20.8853 136.898 20.051 135.842 19.4381C134.821 18.8252 133.663 18.5188 132.369 18.5188C130.394 18.5188 128.76 19.1828 127.466 20.5107C126.172 21.8046 125.525 23.4731 125.525 25.5161C125.525 27.5251 126.172 29.1935 127.466 30.5215C128.76 31.8154 130.394 32.4623 132.369 32.4623C133.697 32.4623 134.872 32.1729 135.894 31.594C136.949 30.9811 137.732 30.1469 138.243 29.0914L143.963 32.3602C142.84 34.3691 141.256 35.9865 139.213 37.2123C137.17 38.4041 134.906 39 132.42 39Z",
    fill: "#121826"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.595 17.14C110.208 15.5056 111.213 14.2798 112.609 13.4626C114.039 12.6454 115.622 12.2368 117.359 12.2368V19.5917C115.35 19.3533 113.545 19.7619 111.945 20.8175C110.378 21.873 109.595 23.6266 109.595 26.0782V38.2852H103.007V12.7476H109.595V17.14Z",
    fill: "#121826"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6563 9.68298C92.5667 9.68298 91.6133 9.2914 90.7961 8.50825C90.0129 7.69104 89.6213 6.73764 89.6213 5.64803C89.6213 4.55843 90.0129 3.60502 90.7961 2.78782C91.6133 1.97061 92.5667 1.56201 93.6563 1.56201C94.7799 1.56201 95.7333 1.97061 96.5165 2.78782C97.3337 3.60502 97.7423 4.55843 97.7423 5.64803C97.7423 6.73764 97.3337 7.69104 96.5165 8.50825C95.7333 9.2914 94.7799 9.68298 93.6563 9.68298ZM90.3875 38.2851V12.7475H96.9762V38.2851H90.3875Z",
    fill: "#121826"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5914 39.0002C65.2115 39.0002 60.7679 37.2125 57.2608 33.6373C53.7536 30.062 52 25.6525 52 20.4088C52 15.131 53.7536 10.7215 57.2608 7.18028C60.7679 3.60502 65.2115 1.81738 70.5914 1.81738C73.8262 1.81738 76.8055 2.58351 79.5296 4.11577C82.2876 5.61398 84.4328 7.65699 85.965 10.2448L79.8871 13.769C79.0018 12.1686 77.7419 10.9258 76.1075 10.0405C74.4731 9.12114 72.6344 8.66147 70.5914 8.66147C67.1183 8.66147 64.3091 9.75107 62.164 11.9303C60.0529 14.1095 58.9973 16.9357 58.9973 20.4088C58.9973 23.8478 60.0529 26.657 62.164 28.8362C64.3091 31.0154 67.1183 32.105 70.5914 32.105C72.6344 32.105 74.4731 31.6624 76.1075 30.7771C77.776 29.8577 79.0358 28.6149 79.8871 27.0486L85.965 30.5728C84.4328 33.1606 82.3047 35.2206 79.5806 36.7529C76.8566 38.2511 73.8602 39.0002 70.5914 39.0002Z",
    fill: "#121826"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1152_29232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0c398ebff12aad2db813682fa66ddfa3.svg";
export { ForwardRef as ReactComponent };